import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { GetAuthUser } from '../services/user-accounts';
import { GetUserTeamList } from '../services/user-accounts';

import TeamInfoCard from './team-infocard';

export default function TeamListModule() {

  const asset = GetAuthUser();

  const [loading,setLoading]=useState(true);
  const [data,setData]=useState([]);

  useEffect( () => {
    if (asset){
      const fetchData = async() => {
        setLoading(true);
        setData((await GetUserTeamList(JSON.stringify({
          body: { usid: asset.usid, form: asset.form },
          user: { usid: asset.usid, form: asset.form }
        }))).data);
        setLoading(false);
      }
      fetchData()
    } else {}
  },[asset.usid]);

  if (loading)
  return (<><p className="text-muted small">Please Wait...</p> </>)

  if (data.length===0)
  return (<><p className="text-muted small">No Records</p> </>)

  return (
    <>

      <div className="">

      {data && data.map((item, i) => (
        
        <div className="col" key={i}>
          <Link to={`/bz/team/view/${item.enid}`} className="">

            <TeamInfoCard data={item} />

          </Link>
        
        </div>
      ))}
      </div>
    </>
  )
}